export const unserviced: string[] = [
  `TV`,
  `Dog`,
  `Blocked`,
  `Locked From The Inside`,
  `No Key`,
  `No Fireplace`,
  `Key Not Work`,
  `Skip Per Management`,
  `Minor`,
  `Denied Entry`,
  `OTHER`,
]

// TODO: remove 'went back'
export const servicedWithIssues: string[] = [
  `Missing Chimney Cap`,
  `Missing Damper`,
  `Broken Damper - Other`,
  `Broken Damper - SO`,
  `Broken Damper - WO`,
  `Broken Damper - NC`,
  `Missing Spark Screen`,
  `Damaged Spark Screen`,
  `Damaged Left Panel`,
  `Damaged Back Panel`,
  `Damaged Right Panel`,
  `Damaged Base Panel`,
  `Missing Left Panel`,
  `Missing Back Panel`,
  `Missing Right Panel`,
  `Missing Base Panel`,
  `Completed - Other`,
  `Went Back`,
]

export const servicedNoIssues: string[] = [
  `Completed. No Issues.`,
]
